// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item--active .v-list-item__icon .menu-chevron{transform:rotate(180deg);transition-duration:.5s}.v-list-item--active .v-list-item__icon svg{color:var(--v-primary-base)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
